import { memo, useMemo } from 'react';
import { Avatar, Box, Chip, Paper, Stack, Typography } from '@mui/material';
import { INotification } from '../../interfaces/INotification';
import { useTranslation } from 'react-i18next';
import { ReactLink } from '@dfl/react-security';
import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';
import { getNotificationName } from '../NotificationList/NotificationItem';
import CampaignIcon from '@mui/icons-material/Campaign';

interface NotificationDrawerItemProps {
  notification: INotification;
}

export const NotificationDrawerItem = memo(({ notification }: NotificationDrawerItemProps) => {
  const { t } = useTranslation('notification');

  const userRouter = useMemo(() => `/crm/users/${notification?.data?.owner?._id || ''}/general`, [notification]);

  // const getInitials = (firstName?: string, lastName?: string) => {
  //   const first = firstName?.charAt(0) || '';
  //   const last = lastName?.charAt(0) || '';
  //   return `${first}${last}`.toUpperCase();
  // };

  // const initials = getInitials(notification?.data?.owner?.firstName, notification?.data?.owner?.lastName);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        mb: 1,
        borderBottom: '1px solid',
        borderColor: 'divider',
        borderRadius: 0,
        transition: 'background-color 0.2s',
        '&:hover': {
          bgcolor: 'action.hover',
        },
      }}
    >
      <Stack direction='row' spacing={2}>
        <Box position='relative'>
          <Avatar>
            <CampaignIcon />
          </Avatar>

          {/* <ReactLink underline="none" to={userRouter}> */}
          {/*  <Avatar */}
          {/*    src={getFullUrl(notification?.data?.owner?.avatar?.thumb)} */}
          {/*    sx={{ */}
          {/*      width: 40, */}
          {/*      height: 40, */}
          {/*      bgcolor: 'primary.main', */}
          {/*      fontSize: '0.875rem', */}
          {/*      fontWeight: 600, */}
          {/*    }} */}
          {/*  > */}
          {/*    {initials} */}
          {/*  </Avatar> */}
          {/* </ReactLink> */}
        </Box>

        <Box flex={1}>
          <Stack spacing={0.5}>
            <Typography variant='body2'>
              <ReactLink underline='none' to={userRouter} sx={{ fontWeight: 600, color: 'text.primary' }}>
                {notification?.data?.owner?.firstName} {notification?.data?.owner?.lastName}
              </ReactLink>{' '}
              <Typography component='span' variant='body2' color='text.secondary'>
                {t(`action.${notification?.type}`)}
              </Typography>
            </Typography>

            <Stack direction='row' spacing={1} alignItems='center'>
              <Typography variant='caption' color='text.secondary'>
                {formatDistanceToNow(new Date(notification?.createdAt || new Date()), {
                  addSuffix: true,
                  locale: es,
                })}
              </Typography>
              <Typography variant='caption' color='text.secondary'>
                •
              </Typography>
              <ReactLink underline='none' to={getNotificationName(notification?.data, notification?.type)}>
                <Typography variant='caption' color='text.secondary' fontWeight={500}>
                  {t(`descriptions.${notification?.type}`, { user: 'Angel' })}
                </Typography>
              </ReactLink>
            </Stack>

            {/* Content */}
            {notification?.message && (
              <Box
                sx={{
                  mt: 1,
                  p: 1.5,
                  bgcolor: 'grey.50',
                  borderRadius: 1,
                  borderLeft: '3px solid',
                  borderColor: 'primary.main',
                }}
              >
                <Typography variant='body2' color='text.secondary'>
                  {notification?.message}
                </Typography>
              </Box>
            )}

            {/* Tags */}
            {notification?.important && (
              <Stack direction='row' spacing={1} mt={1}>
                <Chip label='Important' size='small' color='error' sx={{ height: 24 }} />
              </Stack>
            )}
          </Stack>
        </Box>
      </Stack>
    </Paper>
  );
});

NotificationDrawerItem.displayName = 'NotificationDrawerItem';
